import * as React from 'react'
import { withRouter } from 'react-router'
import qs from 'qs'
import _ from 'lodash'

import Icon from '../../../../components/ui/Icon/Icon'
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import InputWithSuggestion from '../../../../components/ui/InputWithSuggestion/InputWithSuggestion'
import LeaveModal from '../../../../components/home/LeaveModal/LeaveModal'
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import SearchModal from '../../../../components/home/SearchModal/SearchModal'
import {
  StyledBanner,
  BannerContent,
  BannerDescription,
  RewardsCatalogTitle,
  Heading,
  FormContainer,
  SelectMallButton,
  Content,
  StyledCatalogList,
  ErrorCard,
  ZingIconComponent,
  StyledLink,
  StyledShopDineCard,
  CardContent,
  LogoContainer,
  Logo,
  LogoFiller,
  Title,
  OnEmptyResults,
} from './MainView.style'

import * as ExploreApiService from '../../../../services/api/requests/Explore'

import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

class MainView extends React.Component {
  debouncedSearch = _.debounce(search => {
    setGAEvent('rewards_merchant', 'search_merchant_rewards', search)
  }, 250)

  constructor(props) {
    super(props)

    const {
      accessToken,
      match,
      history,
      doGetAllMalls,
      doGetEFoodChoicesFeatured,
      doGetEFoodChoicesNearby,
    } = props
    const { location } = history
    const { mallSlug, viewType } = match.params

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      apiKey: '',
      searchQuery: initialSearch.q || '',
      searched: [],
      malls: [],
      mallList: [],
      searchMallModalState: false,
      showLeaveModal: false,
      selectedEFood: {},
      suggestedCurrentIndex: -1,
      showSuggestion: false,
      selectedEFoodMallSlug: mallSlug,
      selectedCategoryId: 'default',
      selectedCategory: { value: 'default', name: 'All' },
      storeList: [],
      categories: [{ value: 'default', name: 'All' }],
      stores: [],
      searchModalState: false,
      showMerchantModal: false,
      merchantModalData: [],
    }

    switch (viewType) {
      case 'featured':
        // typeLabel = 'All Merchants: Featured Merchants'
        doGetEFoodChoicesFeatured({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
        break
      case 'near-mall':
        // typeLabel = 'All Merchants: Dine'
        doGetEFoodChoicesNearby({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
        break

      default:
        break
    }

    doGetAllMalls(this.setState.bind(this))
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
  }

  getRestaurants = mallSlug => {
    const {
      match,
      accessToken,
      doGetEFoodChoicesFeatured,
      doGetEFoodChoicesNearby,
    } = this.props
    const { viewType } = match.params
    switch (viewType) {
      case 'featured':
        doGetEFoodChoicesFeatured({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
        break
      case 'near-mall':
        doGetEFoodChoicesNearby({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
        break

      default:
        break
    }
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const {
      // viewType, viewId,
      mallSlug,
    } = match.params
    const {
      // viewType: prevViewType,
      // viewId: prevViewId,
      mallSlug: prevMallSlug,
    } = prevProps.match.params

    if (mallSlug !== prevMallSlug) {
      this.getRestaurants(mallSlug)
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    renderServer()
  }

  getRestaurants = mallSlug => {
    const {
      match,
      accessToken,
      doGetEFoodChoicesFeatured,
      doGetEFoodChoicesNearby,
    } = this.props
    const { viewType } = match.params
    switch (viewType) {
      case 'featured':
        doGetEFoodChoicesFeatured({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
        break
      case 'near-mall':
        doGetEFoodChoicesNearby({ accessToken })({
          mallSlug,
          setStores: this.setState.bind(this),
        })
        break
      default:
        break
    }
  }

  searchMallModalToggle = e => {
    const { selectedEFoodMallSlug } = this.state
    const { push } = this.props
    selectedEFoodMallSlug !== ''
      ? this.setState({
          searchMallModalState: false,
        })
      : push('/')
  }

  searchModalToggle = e => {
    this.setState({
      searchModalState: !this.state.searchModalState,
    })
  }

  handleMerchantModal = itemId => {
    ExploreApiService.getStore(itemId).then(response => {
      this.setState({
        showMerchantModal: true,
        merchantModalData: response.data,
      })
    })
  }

  handleMerchantModalClose = e => {
    this.setState({ showMerchantModal: false })
  }

  handleSelectMall = e => {
    this.setState({
      searchMallModalState: true,
    })
  }

  onChangeMall = async mallSlugName => {
    const { setSelectedMallSlug } = this.props
    const { malls } = this.state

    this.setState({
      searchMallModalState: false,
      selectedEFoodMallSlug: mallSlugName,
      selectedEFoodMall: malls.find(mall => mall.mallSlugName === mallSlugName),
    })

    setSelectedMallSlug(mallSlugName)
    this.getRestaurants(mallSlugName)
  }

  onSearchBrand = e => {
    const { stores } = this.state
    const { value: brand } = e.target || {}
    const searchQuery = brand.toLowerCase()

    const searched = stores.filter(store => {
      const storeName = store.name.toLowerCase()

      return storeName.includes(searchQuery)
    })

    this.setState({
      showSuggestion: true,
      suggestedCurrentIndex: -1,
      searched,
      searchQuery: brand,
    })
  }

  sortAlphabetically = (a, b) => {
    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
  }

  handleShowLeaveModal = brand => {
    const { match } = this.props
    const { mallSlug: selectedEFoodMallSlug, viewType } = match.params
    const selectedMall = this.state.malls.find(
      mall => mall.mallSlugName === selectedEFoodMallSlug,
    )

    this.setState({
      showLeaveModal: true,
      selectedEFood:
        viewType === 'near-mall'
          ? { ...brand, nearby_mall: selectedMall.name, mall: null }
          : { ...brand, mall: selectedMall.name, nearby_mall: null },
    })
  }

  handleCloseLeaveModal = onProceed => {
    if (onProceed) {
      const { selectedEFood } = this.state
      setGAEvent('view_efood_link', 'value', selectedEFood.onlineShopUrl)
      setGAEvent(
        'view_efood_link',
        'nearby_mall_name',
        selectedEFood.nearby_mall,
      )
      setGAEvent('view_efood_link', 'mall', selectedEFood.mall)
    }
    this.setState({
      showLeaveModal: false,
    })
    setTimeout(
      () =>
        this.setState({
          selectedEFood: {},
        }),
      10,
    )
  }

  handleSelectSuggestion = (store, index) => {
    this.setState({
      showSuggestion: false,
      suggestedCurrentIndex: index,
      selectedEFood: store,
      searchQuery: store.name,
      searched: [store],
    })
  }

  displaySelectMalls = () => {
    // e.stopPropagation()
    this.setState({
      searchMallModalState: true,
    })
  }
  onEnter = (selectedSuggestion, queryState, searched) => {
    this.setState({
      selectedEFood: selectedSuggestion,
      searchQuery: queryState,
      searched: searched,
    })
  }

  handleRedirectToRegister = () => {
    const { push } = this.props
    push('/register')
  }

  render() {
    const {
      history,
      showRewardModal,
      rewardModalData,
      rewardModalStatus,
      advanceAccount,
      accessToken,
      push,
      baseUrl,
      setLoyaltyPoints,
      loyaltyPoints,
      setLoyaltyPointsError,
      loyaltyPointsError,
      errorList,
      selectedMallSlug,
      setFavoriteMalls,
      match,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      merchantModalStatus,
      ...theProps
    } = this.props

    const {
      searchQuery: searchQueryState,
      stores,
      searched,
      showLeaveModal,
      selectedEFood,
      showSuggestion,
      // loading,
      // suggestedCurrentIndex,
      // showMerchantModal,
      // merchantModalData,
    } = this.state

    const { mallSlug } = match ? match.params : {}
    const selectedMall = this.state.malls.find(
      mall => mall.mallSlugName === mallSlug,
    )

    const { photos } = selectedMall || {}

    const Banner = () => (
      <StyledBanner image={photos && photos[0]}>
        <BannerContent>
          <BannerDescription>
            <RewardsCatalogTitle>ZingEats</RewardsCatalogTitle>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout
        banner={Banner}
        isEConcierge={true}
        match={match}
        selectedMall={selectedMall}
        {...theProps}
      >
        <Heading>
          <FormContainer>
            <SelectMallButton
              onClick={e => {
                this.handleSelectMall(e)
              }}
            >
              <span>
                {(selectedMall && selectedMall.name) || 'Select Mall'}
              </span>
              <Icon name="caret" />
            </SelectMallButton>
            <InputWithSuggestion
              variant="search"
              whiteOut
              iconColor={'#fff'}
              placeholder="Search Merchant"
              onChange={this.onSearchBrand}
              value={searchQueryState}
              onEnter={this.onEnter}
              showSuggestion={showSuggestion}
              handleSelectSuggestion={this.handleSelectSuggestion}
              dataSource={searched}
            />
          </FormContainer>
        </Heading>
        <Content>
          {stores && stores.length > 0 ? (
            <StyledCatalogList
              dataSource={searchQueryState.length ? searched : stores}
              loadingComponent={() => (
                <ErrorCard>
                  <ZingIconComponent />
                </ErrorCard>
              )}
              renderItem={(merchant, index) => (
                <StyledLink
                  onClick={() => {
                    this.handleShowLeaveModal(merchant)
                  }}
                >
                  <StyledShopDineCard cardImageUrl={merchant.backgroundUrl}>
                    <CardContent>
                      <LogoContainer cardImageUrl={merchant.backgroundUrl}>
                        {merchant.logoUrl ? (
                          <Logo src={merchant.logoUrl} />
                        ) : (
                          <LogoFiller>&nbsp;</LogoFiller>
                        )}
                      </LogoContainer>
                      <Title>{merchant.name}</Title>
                    </CardContent>
                  </StyledShopDineCard>
                </StyledLink>
              )}
            />
          ) : (
            <OnEmptyResults />
          )}
        </Content>

        {/* <SelectMallPromptModal
          show={!this.state.searchMallModalState && !selectedMall}
          onConfirmClick={this.displaySelectMalls}
        /> */}

        <SearchMallModal
          modalState={this.state.searchMallModalState}
          onClose={this.searchMallModalToggle}
          malls={this.state.malls}
          push={push}
          match={match}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          baseUrl={baseUrl}
          currentMall={selectedMall && selectedMall.name}
          onChangeMall={this.onChangeMall}
          selectedMall={selectedMall}
          deviceLocation={deviceLocation}
          displayClose={selectedMall && selectedMall.name !== ''}
          favoriteMalls={favoriteMalls}
          setSelectedMallSlug={setSelectedMallSlug}
          efood
        />

        {this.state.searchModalState && (
          <SearchModal
            altTitle={'ZingEats'}
            onCloseSelectMall={this.handleCloseSelectMall}
            onClose={this.searchModalToggle}
            onCloseMerchant={this.handleMerchantModalClose}
            onSelectMerchant={this.handleMerchantModal}
            initialMall={selectedMall}
            malls={this.state.malls}
            mallList={this.state.mallList}
            push={push}
            match={match}
            contentType={2}
            accessToken={accessToken}
            favoriteMalls={favoriteMalls}
            deviceLocation={deviceLocation}
            setFavoriteMalls={setFavoriteMalls}
            isEfoodChoices={true}
          />
        )}
        <LeaveModal
          show={showLeaveModal}
          onClose={() => {
            this.handleCloseLeaveModal()
          }}
          onAltClose={!accessToken && this.handleRedirectToRegister}
          altCloseTitle={!accessToken && 'Join Now'}
          isError={selectedEFood && !selectedEFood.onlineShopUrl}
          errorMessage={'No merchant link found'}
          to={
            selectedEFood.onlineShopUrl
              ? /https:\/\/[a-zA-Z0-9]+/.test(selectedEFood.onlineShopUrl)
                ? selectedEFood.onlineShopUrl
                : `https://${selectedEFood.onlineShopUrl}`
              : ''
          }
          onProceed={() => {
            this.handleCloseLeaveModal(true)
          }}
          isLoggedIn={accessToken}
          promoCode={selectedEFood && selectedEFood.promoCode}
        />
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
